import './App.css';
import Row from './Row';
import requests from './requests';
import Banner from './Banner';
import Nav from './Nav';

function App() {
  return (
    <div className="app">
     
    <Nav/>

    <Banner/>

     <Row title="NETFLIX ORINIGNALS" fetchUrl={ requests.fetchNetflixOriginals }
      isLargeRow
     />

     <Row title="Trending Now" fetchUrl={ requests.fetchTrending }/>

     <Row title="Action Movies" fetchUrl={ requests.fetchActionMovies }/>

     <Row title="Horror Movies" fetchUrl={ requests.fetchHorrorMovies }/>

     <Row title="Romance Movies" fetchUrl={ requests.fetchRomanceMovies }/>

     <Row title="Documentris" fetchUrl={ requests.fetchDocumentaries }/>


     


    </div>
  );
}

export default App;
